var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLabel',{attrs:{"title":"考勤比例"}},_vm._l((_vm.configs),function(config){return _c('RingChart',{key:config.key,attrs:{"config":config,"list":_vm.list}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }